import { Link } from "gatsby"
import React from "react"
import "./endingSection.scss"
import ctaBG from "../../../images/Final CTA.webp"

function EndingSection() {
  return (
    <div className="ending-section">
      <img src={ctaBG} alt="background-image" />
      <div className="main-content">
        <h2>
          Ready to take your <span>AI to Production & Beyond?</span>
        </h2>
        <div className="offers-cta-links">
          <div className="new-buttons-wrapper">
            <div className={`new-button-container`}>
              <Link to={"/book-demo"}>
                <button className={"old-design new-blue standout"}>
                  {/* {cardData?.cta?.cta_name} */}
                  Schedule a Consultation
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EndingSection
